import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CommunicationWeekday } from 'notable-common';

import { isDefined } from 'common';

interface WeekDaysSelectorProps {
  selectedDays?: CommunicationWeekday[];
  onChange: (days: CommunicationWeekday[]) => void;
  disabled?: boolean;
}

export function WeekDaysSelector(props: WeekDaysSelectorProps) {
  const { selectedDays = [], onChange, disabled = false } = props;

  return (
    <ToggleButtonGroup
      value={selectedDays}
      onChange={(_, newValue) => {
        if (isDefined(newValue)) {
          onChange(newValue);
        }
      }}
      disabled={disabled}
      size="small"
      fullWidth
    >
      {Object.values(CommunicationWeekday).map((day) => (
        <ToggleButton key={day} value={day} aria-label={day}>
          {day.substring(0, 3)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
